/* import __COLOCATED_TEMPLATE__ from './merged-conversation-event-group.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import Component from '@glimmer/component';
import type PartGroup from 'embercom/objects/inbox/conversation-stream/part-group';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import type MergedConversationReply from 'embercom/objects/inbox/renderable/merged-conversation-reply';
import { helper } from '@ember/component/helper';
import { type MergedConversationReplyPart } from 'embercom/components/inbox2/conversation-stream/event-parts/merged-conversation-reply';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { FEATURE_FLAG_NAME } from 'embercom/lib/inbox2/event-text-truncation';

interface MergedConversationPart extends RenderablePart {
  renderableData: MergedConversationReply;
}

export interface MergedConversationEventGroupParts extends PartGroup {
  parts: Array<MergedConversationPart>;
}

interface Args {
  partGroup: MergedConversationEventGroupParts;
  isTicketStream: boolean;
  isPreviewPanel: boolean;
}

interface Signature {
  Args: Args;
}

export default class MergedConversationEventGroup extends Component<Signature> {
  @service declare session: Session;

  get isConversationEventsUiImprovementsEnabled(): boolean {
    if (!this.session.isWorkspaceLoaded) {
      return false;
    }
    return this.session.workspace.isFeatureEnabled(FEATURE_FLAG_NAME);
  }

  get renderableTypes() {
    return RenderableType;
  }

  convertToEventReplyType = helper(function ([part]: [any]): MergedConversationReplyPart {
    return part as unknown as MergedConversationReplyPart;
  });
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::PartGroups::MergedConversationEventGroup': typeof MergedConversationEventGroup;
    'inbox2/conversation-stream/part-groups/merged-conversation-event-group': typeof MergedConversationEventGroup;
  }
}
